// DS: MO3.9
import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { getDeviationDiscount } from '../../../../utils/deviations';
import s from './DeviationThumbDiscountLabel.scss';
const DeviationThumbDiscountLabel = ({ className, deviation, textVariant = 'up-to-x-off' })=>{
    const { t } = useTranslation();
    const { discount, formattedDiscountDollarAmount } = getDeviationDiscount(deviation);
    if (!discount) {
        return null;
    }
    let label;
    if (textVariant === 'up-to-x-off') {
        var _discount_amount;
        if (discount === null || discount === void 0 ? void 0 : (_discount_amount = discount.amount) === null || _discount_amount === void 0 ? void 0 : _discount_amount.percent) {
            label = t('deviationview.thumb.discountLabel.upToPercentOff', {
                percentage: discount.amount.percent.toFixed(0)
            });
        }
    } else if (textVariant === 'sale-x-off') {
        var _discount_amount1;
        if (discount === null || discount === void 0 ? void 0 : (_discount_amount1 = discount.amount) === null || _discount_amount1 === void 0 ? void 0 : _discount_amount1.percent) {
            label = t('deviationview.thumb.discountLabel.salePercentOff', {
                percentage: discount.amount.percent.toFixed(0)
            });
        }
    } else if (textVariant === 'you-save-x') {
        var _discount_amount2;
        if (discount === null || discount === void 0 ? void 0 : (_discount_amount2 = discount.amount) === null || _discount_amount2 === void 0 ? void 0 : _discount_amount2.usd) {
            label = t('deviationview.thumb.discountLabel.youSave', {
                dollarAmount: formattedDiscountDollarAmount
            });
        }
    }
    if (!label) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], className)
    }, /*#__PURE__*/ React.createElement("abbr", {
        title: label
    }, label));
};
DeviationThumbDiscountLabel.displayName = 'DeviationThumbDiscountLabel';
export default DeviationThumbDiscountLabel;

//# sourceMappingURL=DeviationThumbDiscountLabel.js.map